<template>
    <div class="container component-spacing">
        <h1 class="title" >Contact Us</h1>
        <p class="we-are-ready">We are ready to lead you through your journey towards Water 4.0</p>
        <div class="row flex-container">
            <div class="col-sm-6 text-left">
                <h5 class="contact-us-let-us-know">Let us know how we can help you:</h5>
                <h6 class="contact-us-title">LEARN HOW R-TAP FITS YOUR NEEDS</h6>
                <p class="contact-us-message">Request a discussion with our team, or send us an email<br>
                 through the form on the right.</p>
                <h6 class="contact-us-title">REQUEST CUSTOMER SUPPORT</h6>
                <p class="contact-us-message">We are here to help you. Send your questions and concerns<br>
                 to support@hirayawater.com.</p>
                <h6 class="contact-us-title">JOIN THE TEAM</h6>
                <p class="contact-us-message">Know about employment and internship opportunities in<br>
                 Hiraya Water by inquiring at joinus@hirayawater.com.</p>
                 <br>
                 <h5 class="contact-us-let-us-know">Points of contact</h5>
                 <br>
                 <h6 class="contact-us-title">MAIN OFFICE</h6>
                 <p class="contact-us-message">502 - 503 Jocfer Bldg., Commonwealth Ave., Quezon City,<br>
                 Philippines 1127</p>
                 <h6 class="contact-us-title">GENERAL INFORMATION AND SALES</h6>
                 <p class="contact-us-message">(02) 8282 - 3252<br>
                 info@hirayawater.com</p>
                 <h6 class="contact-us-title">FOLLOW US</h6>
                <a class="img-fluid social-media-icons" href="https://www.facebook.com/hirayawater/">
                    <img src="../../assets/img/social-media-icons/facebook.png" alt="logo" style="width:5%;">
                </a>
                <a class="img-fluid social-media-icons" href="https://twitter.com/hirayawater">
                    <img src="../../assets/img/social-media-icons/twitter.png" alt="logo" style="width:5%;">
                </a>
                <a class="img-fluid social-media-icons" href="https://www.linkedin.com/company/hirayawater/">
                    <img src="../../assets/img/social-media-icons/linkedin.png" alt="logo" style="width:5%;">
                </a>
                <br>
                <img src="../../assets/img/contactus/maps.png" alt="logo" style="width:100%;">
            </div>
            <div class="col-sm-6" style="padding-bottom:80px;" >
                <form method="POST" @submit.prevent="sendEmail()">
                    <input type="text" name="first_name" v-model="first_name" placeholder="FIRST NAME*" required>
                    <br>
                    <br>
                    <input type="text" name="last_name" v-model="last_name" placeholder="LAST NAME*" required>
                    <br><br>
                    <input type="text" name="company_name" v-model="company_name" placeholder="COMPANY NAME*" required>
                    <input type="email" name="company_email" v-model="company_email" placeholder="COMPANY EMAIL*" required>
                    <input type="text" name="contact_number" v-model="contact_number" placeholder="CONTACT NUMBER*" required>
                    <input type="text" name="job_title" v-model="job_title" placeholder="JOB TITLE*" required>
                    <textarea rows = "10" cols = "10" name = "your_message" v-model="your_message" placeholder="YOUR MESSAGE*" required> </textarea>
                    <div class="form-group">
                        <div id="recaptcha" class="g-recaptcha" data-sitekey="6Lfc3rwUAAAAAIvenIPAZuz7eD9t4fWrcXcHaVTR"></div>
                    </div>
                    <div class="text-left">
                        <input type="submit" name="send" class="send-message" value="">
                    </div>
                </form> 
                
            </div>
        </div>

    </div>
</template>
<script>
import axios from "axios";
import swal from 'sweetalert';

const PROD_URL = 'https://rtap.hirayawater.com'
const DEV_URL = 'http://127.0.0.1:8000'
// var RTAP_URL = PROD_URL;
var RTAP_URL = PROD_URL;

export default {
  data() {
      return {
          first_name: '',
          last_name: '',
          company_name: '',
          company_email: '',
          contact_number: '',
          job_title: '',
          your_message: ''
      }
  },
  methods: {
      async sendEmail()
       {
           const params = new URLSearchParams();
            params.append('first_name', this.first_name);
            params.append('last_name', this.last_name);
            params.append('company_name', this.company_name);
            params.append('company_email', this.company_email);
            params.append('contact_number', this.contact_number);
            params.append('job_title', this.job_title);
            params.append('your_message', this.your_message);

            await axios({
            method: 'post',
            url:  `${RTAP_URL}/api/v3/contactus`,
            data: params
            }).then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });
            swal("Thank you!", "Will get back to you shortly.", "success");
            this.clearForm();
            grecaptcha.reset();
      },
      clearForm() {
            this.first_name = "";
            this.last_name = "";
            this.company_name = "";
            this.company_email = "";
            this.contact_number = "";
            this.job_title = "";
            this.your_message = "";
      }
  }
  
};

</script>
<style scoped>
.send-message {
    background-image: url('../../assets/img/contactus/contact-us-button.png');
    border: 0;
    width:35%;
    height:25%;
    padding-right: 185px;
    padding-bottom:92px;
    cursor: pointer;
    background-color: transparent;
    background-repeat: no-repeat;
    background-attachment: scroll;
}
.title {
    padding-bottom:0;
}
.we-are-ready {
    font: 15px gil-medium;
    color:black;
    padding-bottom:30px;
}
.contact-us {
  font: 36px gil-bold, sans-serif;
  color:#00b6ae;
  
}
.contact-us-let-us-know {
  font: 24px gil-bold;
  color:#f37121;
}
.contact-us-title {
  font: 18px gil-bold;
  color: #244093;
  text-align: left;
}
.contact-us-message {
  font: 12px gil-medium;
  color: black;
  line-height: 23px;
}

input[type=text],input[type=email] , textarea {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #00b6ae;
  border-radius: 4px;
  box-sizing: border-box;
  color: #00b6ae;
  font: 18px gil-bold;
  text-align: left;

}
::placeholder {
  color: #00b6ae;
  opacity: 1; 
  text-align: left;
}
</style>